import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { getSOPsDocumentAPI } from "../../apiRequests/getTimelyReviewSOPS/getLogDataAPI";
import { TableRowData } from "../../types/dataType";
import TimelyCompletionSOPReviewTable from "../../Components/TimelyCompletionSOPReviewTable/TimelyCompletionSOPReviewTable";
import { convertToPercentage } from "../../utils/commonUtils";
import LoadingPage from "../../Components/LoadingPage/LoadingPage";

interface SOPReviewProps {
    isDashboard?: boolean;
    timelyReviewKPIData?: TableRowData[];
}

const SOPReview = (props: SOPReviewProps) => {
    const [sopKPI, setSopKPI] = useState(0);
    const [timelyReviewKPIData, setTimelyReviewKPIData] = useState<TableRowData[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        !props.isDashboard && loadDataOfSOPsReviewTimelyCompletionOfReviews();
    }, []);

    useEffect(() => {
        if (props.isDashboard) {
            setTimelyReviewKPIData(props.timelyReviewKPIData || []);
        }
    }, [props.isDashboard, props.timelyReviewKPIData]);

    useEffect(() => {
        const numberOfCompletionReviewsKPI = timelyReviewKPIData.filter(pageIsReviewed).length;
        const timeCompletionReviewsKPI = numberOfCompletionReviewsKPI / timelyReviewKPIData.length;
        setSopKPI(timeCompletionReviewsKPI);
    }, [timelyReviewKPIData]);
    const loadDataOfSOPsReviewTimelyCompletionOfReviews = async () => {
        setIsLoading(true);

        const data = await getSOPsDocumentAPI();
        setTimelyReviewKPIData(data);

        const numberOfCompletionReviewsKPI = data.filter(pageIsReviewed).length;
        const numberOfUncompletedDocuments = data.filter((data) => !data.reviewDate).length;
        const timeCompletionReviewsKPI = numberOfCompletionReviewsKPI / (data.length - numberOfUncompletedDocuments);
        setSopKPI(timeCompletionReviewsKPI);
        setIsLoading(false);
    };

    const convertMMDDYYYYToTimestamp = (date: string) => {
        const [month, day, year] = date.split("/");
        return new Date(`${year}-${month}-${day}`).getTime();
    };

    const pageIsReviewed = (data: TableRowData) => {
        return data.isPageReviewed;
    };

    const renderTableOfTimelyReviewKPI = () => {
        return <TimelyCompletionSOPReviewTable rows={timelyReviewKPIData} setTimelyReviewKPIData={setTimelyReviewKPIData} />;
    };

    return (
        <Container>
            {isLoading ? (
                <LoadingPage></LoadingPage>
            ) : (
                <div>
                    <h1>Current Progress: {convertToPercentage(sopKPI)}</h1>
                    <h2>Number of SOP: {timelyReviewKPIData.length - timelyReviewKPIData.filter((data) => !data.reviewDate).length}</h2>
                    <h2>
                        Current Date {"<"} Review Date: {timelyReviewKPIData.filter(pageIsReviewed).length}
                    </h2>
                    {renderTableOfTimelyReviewKPI()}
                </div>
            )}
        </Container>
    );
};

export default SOPReview;
